<div class="modal where-find-activation-code">
  <div class="model-container">
    <div class="modal-header">
        <h3 class="modal-heading" translate>activate-code-modal.Where-Activation-Code</h3>
        <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon"
          width="28" height="28">
    </div>
    <div class="modal-body">
      <div class="contents">
        <div class="desc">
          <p class="subtitle" translate>activate-code-modal.sim-card-has <b translate> activate-code-modal.20-number</b> <span translate> activate-code-modal.last-digits</span>
          <b translate> activate-code-modal.9-digits</b> <span translate>activate-code-modal.of-that</span></p>
          <p class="note" translate>
          activate-code-modal.look-for-it
          </p>
        </div>
        <div class="image-part">
          <img src="/assets/img/activation-sim-card.svg" alt="sim img" width="270" height="201">
        </div>
      </div>
      <div class="modal-actions">
        <button class="button primary" aria-label="Got it!" (click)="closeDialog(true)" translate>
          activate-code-modal.got-it
        </button>
      </div>
    </div>
  </div>
</div>